const ORDER_HASH_COOKIE_KEY = "public_order_hash";
const ORDER_HASH_VALIDITY_DAYS = 14;

// Simple pub/sub for cookie changes (for useSyncExternalStore)
type Listener = () => void;
const listeners = new Set<Listener>();

export function subscribeToOrderHash(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

function notifyListeners() {
    listeners.forEach((listener) => listener());
}

/**
 * Stores the order hash in a cookie
 */
export function storeOrderHash(orderHash: string): void {
    try {
        const expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + ORDER_HASH_VALIDITY_DAYS);

        document.cookie = `${ORDER_HASH_COOKIE_KEY}=${orderHash}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
        notifyListeners();
    } catch (error) {
        console.error("Failed to store order hash in cookie:", error);
    }
}

/**
 * Retrieves the order hash from cookie
 */
export function getOrderHash(): string | null {
    try {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${ORDER_HASH_COOKIE_KEY}=`);

        if (parts.length === 2) {
            const cookieValue = parts.pop()?.split(";").shift();
            return cookieValue || null;
        }

        return null;
    } catch (error) {
        console.error("Failed to retrieve order hash from cookie:", error);
        return null;
    }
}

/**
 * Removes the order hash from cookie
 */
export function clearOrderHash(): void {
    try {
        document.cookie = `${ORDER_HASH_COOKIE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
        notifyListeners();
    } catch (error) {
        console.error("Failed to clear order hash from cookie:", error);
    }
}
